// THE APP'S VERSION — BUG-032.
//
// `dist/v0.1.0`'s About row read "AdOrchestrator 0.0.0" inside a snapshot the gallery calls v0.1.0, because the
// string was a hand-written constant that nobody remembered to move. It is now READ FROM `apps/web/package.json`
// AT BUILD TIME: `vite.config.ts` substitutes `__APP_VERSION__` with that file's `version`, so the number the
// About row prints, the number `X-Client-Version` sends and the number in the package are one fact with one
// place to change it. Bumping the app's version is a line in `package.json`, and the snapshot's folder name
// is the project-manager's to keep in step (an Inbox note asks QA to assert the pair).
//
// The smallest honest mechanism, and it stays honest when there is nothing to read: a build whose version is
// missing, empty or still the npm default `0.0.0` says **"development build"** rather than printing a version
// it does not have. `0.0.0` is not a release; it is the absence of one.

declare const __APP_VERSION__: string | undefined;

/** What a build with no version of its own calls itself. Never a number, never "0.0.0". */
export const DEVELOPMENT_BUILD = 'development build';

/** The npm default, which means "this package has never been versioned" — not "version nought". */
const UNVERSIONED = '0.0.0';

/**
 * The raw version, exactly as `package.json` carries it, or `null` when this build has none. The transport
 * sends this (or nothing); only the About row uses the label below.
 */
export function readVersion(raw: string | undefined): string | null {
  const trimmed = (raw ?? '').trim();
  if (trimmed === '' || trimmed === UNVERSIONED) return null;
  return trimmed;
}

/** What the About row prints after the product name. */
export function versionLabel(raw: string | undefined): string {
  return readVersion(raw) ?? DEVELOPMENT_BUILD;
}

/** Substituted by Vite from `apps/web/package.json`; `undefined` under a bundler that did not define it. */
const DEFINED = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : undefined;

/** The version this build has, or `null` — the one fact both readers below are derived from. */
export const APP_VERSION = readVersion(DEFINED);

/** "0.1.0", or "development build". What Settings → About shows (REQ-282). */
export const APP_VERSION_LABEL = versionLabel(DEFINED);
